export class AwsKeyspacesDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "keyspaceName",
            "baseName": "keyspaceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "writeCapacityUnits",
            "baseName": "writeCapacityUnits",
            "type": "number",
            "format": ""
        },
        {
            "name": "restoreBillingMode",
            "baseName": "restoreBillingMode",
            "type": "DynamoDbBillingMode",
            "format": ""
        },
        {
            "name": "restoreTtl",
            "baseName": "restoreTtl",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsKeyspacesDestination.attributeTypeMap;
    }
    constructor() {
    }
}
